export const PRINT_SCALE_FACTOR = 0.8
